import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { X, Check, FileText, Smartphone, Clock, Zap, AlertTriangle } from 'lucide-react';

const ProblemSolution = () => {
  const { t } = useLanguage();
  
  return (
    <section className="problem-solution-section">
      <div className="section-container">
        <div className="comparison-grid">
          <div className="comparison-card problem-card">
            <div className="card-icon-header problem-header">
              <X className="header-icon" size={32} />
            </div>
            
            <h2 className="card-title">{t('problemTitle')}</h2>
            <p className="card-description">{t('problemDesc')}</p>
            
            <div className="card-image-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_scan-match-parts/artifacts/qu70drvn_workshop.jpg"
                alt="Frustrated worker searching documents"
                className="card-image"
              />
            </div>
            
            <ul className="feature-list problem-list">
              <li>
                <FileText size={18} />
                <span>{t('problemItem1')}</span>
              </li>
              <li>
                <AlertTriangle size={18} />
                <span>{t('problemItem2')}</span>
              </li>
              <li>
                <Clock size={18} />
                <span>{t('problemItem3')}</span>
              </li>
            </ul>
          </div>
          
          <div className="comparison-card solution-card">
            <div className="card-icon-header solution-header">
              <Check className="header-icon" size={32} />
            </div>
            
            <h2 className="card-title">{t('solutionTitle')}</h2>
            <p className="card-description">{t('solutionDesc')}</p>
            
            <div className="card-image-container">
              <img 
                src="https://customer-assets.emergentagent.com/job_scan-match-parts/artifacts/u5v1k3ot_scannad.jpg"
                alt="Phone scanning hydraulic motor"
                className="card-image"
              />
            </div>
            
            <ul className="feature-list solution-list">
              <li>
                <Smartphone size={18} />
                <span>{t('solutionItem1')}</span>
              </li>
              <li>
                <Zap size={18} />
                <span>{t('solutionItem2')}</span>
              </li>
              <li>
                <Check size={18} />
                <span>{t('solutionItem3')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
